import { EmployeeAddressDto } from './employee-address-dto';
import { EmployeeDto } from './employee-dto';

export interface EmployeeDetailsDto extends EmployeeDto {
  IdCardType?: string;
  IdCardNumber?: string;
  IdCardExpiration?: Date;

  TWICNumber?: string;
  TWICExpiration?: Date;

  Notes?: string;

  /** WI 34635: HR checked a Caution rehire status; required with CautionReason when HR registers one. */
  CautionAcknowledged?: boolean;
  CautionReason?: string;
  /** WI 34635 slice 5: HR confirmed the email is shared with other packet users. */
  SharedEmailConfirmed?: boolean;

  HrDepartment?: string;
  JobTitle?: string;

  HomeAddress?: EmployeeAddressDto;
  MailingAddress?: EmployeeAddressDto;
}
